import {CacheClearJobStatus} from "../features/urls/deleteUrls/DeleteUrlsState";
import {AdaptiveType} from "../features/urls/UrlsState";
import {get as httpGet, post as httpPost, postFormData as httpPostFormData} from "./BackendService";

interface ListUrlsResponse {
  readonly count?: number;
  readonly urls: Array<{
    readonly url: string;
    readonly adaptiveType: AdaptiveType;
  }>;
}

export interface ListUrlsResult {
  readonly count?: number;
  readonly urls: Array<{
    readonly url: string;
    readonly adaptiveType: AdaptiveType;
  }>;
}

export const listUrls = async (
  userId: number,
  limit: number = 1000,
  offset: number = 0,
  filter?: string,
  regex?: string,
  adaptiveType?: AdaptiveType,
  includeCount: boolean = true
): Promise<ListUrlsResult> => {
  const queryData: any = {
    limit,
    offset
  };
  if (filter) queryData.filter = filter;
  if (regex) queryData.regex = regex;
  if (adaptiveType && adaptiveType !== AdaptiveType.all) queryData.adaptiveType = adaptiveType;
  if (!includeCount) queryData.includeCount = "false";

  if (!regex && !filter) queryData.filter = "%";

  const query = new URLSearchParams(queryData);
  return httpGet<ListUrlsResponse>(`/users/${userId}/urls${Object.keys(queryData).length > 0 ? `?${query.toString()}` : ""}`);
};

interface GetCacheClearJobStatusResponse {
  readonly status: CacheClearJobStatus;
  readonly deletedCount?: number;
}

export interface GetCacheClearJobStatusResult {
  readonly status: CacheClearJobStatus;
  readonly deletedCount?: number;
}

export const cacheClearJobStatus = (userId: number): Promise<GetCacheClearJobStatusResult> => {
  return httpGet<GetCacheClearJobStatusResponse>(`/users/${userId}/urls/jobs/cacheClear/status`);
};

interface CreateCacheClearJobResponse {
  readonly status: CacheClearJobStatus;
}

export interface CreateCacheClearJobResult {
  readonly status: CacheClearJobStatus;
}

export const cacheClearJob = (
  userId: number,
  filter?: string,
  regex?: string,
  adaptiveType?: AdaptiveType
): Promise<CreateCacheClearJobResult> => {
  const postData: any = {};
  if (filter) postData.filter = filter;
  if (regex) postData.regex = regex;
  if (adaptiveType && adaptiveType !== AdaptiveType.all) postData.adaptiveType = adaptiveType;

  if (!filter && !regex) postData.filter = "%";

  return httpPost<CreateCacheClearJobResponse>(`/users/${userId}/urls/jobs/cacheClear`, postData);
};

export interface BulkDeleteConflict {
  readonly id: string;
  readonly reason: "url" | "adaptive_type";
}

export interface BulkDeletePreviewResult {
  readonly eligibleCount: number;
  readonly currentlyCachedCount: number;
  readonly notFound: string[];
  readonly conflicts: BulkDeleteConflict[];
  readonly invalidRows: number;
  readonly duplicatesRemoved: number;
  readonly contentHash: string;
}

export interface BulkDeleteConfirmResult {
  readonly status: CacheClearJobStatus;
}

export const bulkDeletePreview = (userId: number, file: File): Promise<BulkDeletePreviewResult> => {
  const formData = new FormData();
  formData.append("file", file);

  return httpPostFormData<BulkDeletePreviewResult>(`/users/${userId}/urls/jobs/bulkDelete`, formData);
};

export const bulkDeleteConfirm = (userId: number, file: File, contentHash: string): Promise<BulkDeleteConfirmResult> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("confirmHash", contentHash);

  return httpPostFormData<BulkDeleteConfirmResult>(`/users/${userId}/urls/jobs/bulkDelete`, formData);
};
